import {methods, ServiceMaker} from "./indecx";

const { GET } = methods;

export const getCasesByState = () => ServiceMaker(`/stats`,GET)

export const getContatcs = () => ServiceMaker(`/contacts`,GET)


